import React, { ReactChild } from "react";
import styled from "styled-components";

interface Props {
  children: ReactChild;
  onClick?: () => void;
}

const MainButton = ({ children, onClick }: Props) => {
  return <Button onClick={onClick}>{children}</Button>;
};

export default MainButton;

const Button = styled.button`
  font-family: "iceSotong-Rg";

  cursor: pointer;

  color: white;
  border: none;

  border-radius: 10px;
  font-weight: 600;
  font-size: 20px;
  padding: 10px;
  background-image: linear-gradient(#e0583a, #2c0000);

  &:active {
    transform: scale(0.9);
  }
`;
